import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Table, Spinner, Button, Input } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";

const SuggestionsFeedbackTab = ({ partnerId, onChatClick }) => {
  const { AuthReducer: { auth } } = useSelector((state) => state);
  
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');

  useEffect(() => {
    if (partnerId) {
      fetchPartnerFeedbacks();
    } else {
      setLoading(false);
    }
  }, [partnerId, search, sort]);

  const fetchPartnerFeedbacks = () => {
    setLoading(true);
    axios.get(`/api/admin/v1/partner-feedback/${partnerId}?search=${search}&sort=${sort}`, {
        headers: { Authorization: `Bearer ${auth?.token}` },
      })
      .then((res) => {
        setFeedbacks(res.data.feedback || []);
      })
      .catch((error) => {
        toast.error("Error fetching partner feedbacks");
      })
      .finally(() => setLoading(false));
  };


  if (loading) return <Spinner />;

  return (
    <div>
      <h6 className="fw-bold mb-3">Suggestions & Feedback ({feedbacks.length})</h6>
      
      <div className="row mb-3">
        <div className="col-md-4">
          <Input 
            size="sm" 
            value={search} 
            placeholder="Search by subject or email" 
            onChange={(e) => setSearch(e.target.value)} 
          />
        </div>
        <div className="col-md-2 offset-md-6">
          <Input type="select" size="sm" value={sort} onChange={(e) => setSort(e.target.value)}>
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
          </Input>
        </div>
      </div>
      <Table hover responsive>
        <thead>
          <tr>
            <th>SL. No.</th>
            <th>Subject</th>
            <th>Category</th>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {feedbacks.length === 0 ? (
            <tr><td colSpan="8">No feedback found for this partner</td></tr>
          ) : (
            feedbacks.map((feedback, index) => (
              <React.Fragment key={feedback.id}>
                <tr>
                  <td>{index + 1}</td>
                  <td>{feedback.subject}</td>
                  <td>{feedback.category}</td>
                  <td>{feedback.name}</td>
                  <td>{feedback.email}</td>
                  <td>
                    <span className={`badge ${feedback.status ? 'bg-success' : 'bg-warning'}`}>
                      {feedback.status ? 'Resolved' : 'Open'}
                    </span>
                  </td>
                  <td>{new Date(feedback.createdAt).toLocaleDateString()}</td>
                  <td>
                    <Button 
                      color="primary" 
                      size="sm"
                      onClick={() => onChatClick && onChatClick(feedback.id)}
                    >
                      Chat
                    </Button>
                  </td>
                </tr>
              
              </React.Fragment>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default SuggestionsFeedbackTab;